module.exports = __webpack_public_path__ + "static/media/fingerprintAdvandtage.68ae82dc.mp3";